import { dimAligned, dimTextAligned } from "./DIM.js";
import { profile } from "./Power_WB_profile.js";
import { soil } from "./Soil.js";
import { elevation } from "./Elevation.js";
import { base_color } from "./Power_WB_settings.js";

// 01图，基础平面图、剖面图绘制
export function layout(
  svg,
  params_geometry,
  params_bolt,
  scale = 100
) {

  let R = params_geometry.find((item) => item.name === "R");
  let R1 = params_geometry.find((item) => item.name === "R1");
  let R2 = params_geometry.find((item) => item.name === "R2");
  let H1 = params_geometry.find((item) => item.name === "H1");
  let H2 = params_geometry.find((item) => item.name === "H2");
  let H3 = params_geometry.find((item) => item.name === "H3");
  let Hd = params_geometry.find((item) => item.name === "Hd");
  let Ratio = params_geometry.find((item) => item.name === "Ratio");
  let holeDepth = params_geometry.find((item) => item.name === "holeDepth");
  let holeRadius = params_geometry.find((item) => item.name === "holeRadius");
  let holeCushionThick = params_geometry.find(
    (item) => item.name === "holeCushionThick"
  );
  let cushionThick = params_geometry.find((item) => item.name === "cushionThick");
  let extralWidth = params_geometry.find((item) => item.name === "extralWidth");
  let backFillRatio = params_geometry.find(
    (item) => item.name === "backFillRatio"
  );

  if (R1.value < R2.value) {
    R1.value = R2.value;
  }
  let H = H1.value * 1000 + H2.value * 1000 + H3.value * 1000; // 基础总高度

  // 一、 定义01图平面图、剖面图group容器，用黄色绘制~~~~~~~~~~~~~~~~~~
  let b = 1; // 基本线宽
  let layout = svg
    .group()
    .addClass("layout")
    .fill("none")
    .stroke({ color: "white", width: 0.18 * b * scale })
    .font({ size: 3 * scale });

  ////////////////////////////////////////////////////////////////////
  // 三、 定义剖面图group容器~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  ////////////////////////////////////////////////////////////////////
  var [sectionX, sectionY] = [21000, 5000 - H / 2 - 500];
  let section = layout
    .group()
    .addClass("section")
    .stroke({ width: 0.25 * b * scale, color: base_color })
    .translate(sectionX, sectionY)
    .stroke({ color: "white" });

  // 3-1. 绘制轮廓线
  let H_groove = holeDepth.value * 1000; // 中心凹槽深度
  let thick_groove = holeCushionThick.value * 1000; // 中心凹槽垫层厚度
  let p1x = holeRadius.value * 1000; // 中心凹槽半径

  profile(section, params_geometry, params_bolt);

  elevation(
    section, //在哪个group添加elevation
    `+ ${parseFloat(H1.value + H2.value + H3.value - Hd.value).toFixed(3)}`,
    R2.value * 1000, // 引出线端点x坐标
    0, // 引出线端点y坐标
    1, //右侧
    0, // 旋转角度
    scale * 1.3 //出图比例
  );
  elevation(
    section, //在哪个group添加elevation
    '± 0.000',
    -R2.value * 1000, // 引出线端点x坐标
    (H1.value + H2.value + H3.value - Hd.value) * 1000, // 引出线端点y坐标
    -1, //右侧
    0, // 旋转角度
    scale * 1.3 //出图比例
  );



  // 3-2边坡轮廓线：
  let slop_x = (R.value * 1000 + 100 + extralWidth.value * 1000) +
    (
      (Hd.value * 1000 + cushionThick.value * 1000) -
      backFillRatio.value / 100 * (R.value * 1000 - R2.value * 1000 + 100 + extralWidth.value * 1000)
    )
    / (1 / Ratio.value + backFillRatio.value / 100);
  let slop_y = H - Hd.value * 1000 + backFillRatio.value / 100 * (slop_x - R2.value * 1000);
  section.polyline([
    [R.value * 1000 + 100, H + cushionThick.value * 1000],
    [R.value * 1000 + 100 + extralWidth.value * 1000, H + cushionThick.value * 1000],
    [
      slop_x,
      slop_y,
    ],
    [
      slop_x + 500,
      slop_y,
    ],
  ]);

  section.polyline([
    [-R.value * 1000 - 100, H + cushionThick.value * 1000],
    [-R.value * 1000 - 100 - extralWidth.value * 1000, H + cushionThick.value * 1000],
    [
      -slop_x,
      slop_y,
    ],
    [
      -slop_x - 500,
      slop_y,
    ],
  ]);
  // 风机平台面标高
  elevation(
    section, //在哪个group添加elevation
    `-${parseFloat(slop_y / 1000 - (H1.value + H2.value + H3.value - Hd.value)).toFixed(3)}`,
    -slop_x, // 引出线端点x坐标
    slop_y, // 引出线端点y坐标
    -1 //zuo侧
    // rotate, // 旋转角度
    // scale_print = 100 //出图比例
  );
  dimTextAligned(
    section,
    [R2.value * 1000, H - Hd.value * 1000], //起始点坐标
    [
      slop_x, //终止点坐标
      slop_y,
    ],
    `回填土表面，→ ${backFillRatio.value}%`, //文字内容
    0.3, //线宽
    -4,   //偏移量
    scale * 1.2    //比例
  );
  let soil_fill = soil(
    section, //在哪个group添加soil
    R2.value * 1000 + 3000, // x轴坐标
    H - Hd.value * 1000 + 3000 * backFillRatio.value / 100, // y轴坐标
    180 / Math.PI * (backFillRatio.value / 100), // 旋转角度
    50 //比例
  );
  section.use(soil_fill).move(2000, 2000 * backFillRatio.value / 100);
  section
    .use(soil_fill)
    .move(-2 * R2.value * 1000 - 6000, 0)
    .rotate(-2 * 180 / Math.PI * (backFillRatio.value / 100));
  section
    .use(soil_fill)
    .move(-2 * R2.value * 1000 - 8000, 2000 * backFillRatio.value / 100)
    .rotate(-2 * 180 / Math.PI * (backFillRatio.value / 100));

  dimTextAligned(
    section,
    [-R2.value * 1000, H - Hd.value * 1000], //起始点坐标
    [
      -slop_x, //终止点坐标
      slop_y,
    ],
    `${backFillRatio.value}% ← ，回填土表面`, //文字内容
    0.3, //线宽
    -4,   //偏移量
    scale * 1.2    //比例
  );

  dimTextAligned(
    section,
    [R.value * 1000 + 100 + extralWidth.value * 1000, H + cushionThick.value * 1000], //起始点坐标
    [
      slop_x,
      slop_y,
    ], //终止点坐标
    `1:${Ratio.value}`, //文字内容
    0.3, //线宽
    -4,   //偏移量
    scale * 1.2    //比例
  );

  dimTextAligned(
    section,
    [-R.value * 1000 - 100 - extralWidth.value * 1000, H + cushionThick.value * 1000], //起始点坐标
    [
      -slop_x,
      slop_y,
    ], //终止点坐标
    `1:${Ratio.value}`, //文字内容
    0.3, //线宽
    -4,   //偏移量
    scale * 1.2    //比例
  );


  // 3-5 尺寸标注
  // 底部第一道尺寸标注：
  dimAligned(
    section,
    [
      // 标注点信息：
      [-R.value * 1000 - 100 - extralWidth.value * 1000, H],
      [-R.value * 1000 - 100, H],
      [-R.value * 1000, H],
      [-p1x, H],
      [0, H],
      [p1x, H],
      [R.value * 1000, H],
      [R.value * 1000 + 100, H],
      [R.value * 1000 + 100 + extralWidth.value * 1000, H],
    ],
    500, // 尺寸界线偏离距离：
    1300,
    scale * 1.3,
    scale * 1.3
  );
  // 底部第二道尺寸标注：
  dimAligned(
    section,
    [
      // 标注点信息：
      [-R.value * 1000, H],
      [0, H],
      [R.value * 1000, H],
    ],
    1100, // 尺寸界线偏离距离：
    1900,
    scale * 1.3,
    scale * 1.3
  );

  // 顶部尺寸标注：
  dimAligned(
    section,
    (function () {
      if (R2.value == R1.value) {
        return [
          // 标注点信息：
          [R.value * 1000, H3.value * 1000],
          [R2.value * 1000, H3.value * 1000],
          [0, H3.value * 1000],
          [-R2.value * 1000, H3.value * 1000],
          [-R.value * 1000, H3.value * 1000],
        ];
      } else {
        return [
          // 标注点信息：
          [R.value * 1000, H3.value * 1000],
          [R1.value * 1000, H3.value * 1000],
          [R2.value * 1000, H3.value * 1000],
          [0, H3.value * 1000],
          [-R2.value * 1000, H3.value * 1000],
          [-R1.value * 1000, H3.value * 1000],
          [-R.value * 1000, H3.value * 1000],
        ];
      }
    })(),
    0, // 尺寸界线偏离距离：
    500,
    scale * 1.3,
    scale * 1.3
  );

  // 侧面第一道尺寸标注：
  dimAligned(
    section,
    [
      // 标注点信息：
      [0, H + cushionThick.value * 1000],
      [0, H],
      [0, H3.value * 1000 + H2.value * 1000],
      [0, H3.value * 1000],
      [0, 0],
    ],
    R.value * 1000 + H / 3,// 尺寸界线偏离距离：
    R.value * 1000 + H / 3 + 700,// 尺寸界线偏离距离：
    scale * 1.3,
    scale * 1.3
  );
  // 侧面第二道尺寸标注：
  dimAligned(
    section,
    [
      // 标注点信息：
      [0, H],
      [0, 0],
    ],
    R.value * 1000 + 600 + H / 3, // 尺寸界线偏离距离：
    R.value * 1000 + 1300 + H / 3, // 尺寸界线偏离距离：
    scale * 1.3,
    scale * 1.3
  );


  // 锚栓尺寸标注：
  dimAligned(
    section,
    [
      // 标注点信息：
      [R2.value * 1000, H + H_groove + thick_groove],
      [R2.value * 1000, H + H_groove],
      [R2.value * 1000, H],
      [R2.value * 1000, H - Hd.value * 1000],
      [R2.value * 1000, 0],
    ],
    600 // 尺寸界线偏离距离：
  );


  return layout;
}
